module.exports = __webpack_public_path__ + "static/media/action-icon-active.22ac73a9.svg";